import { render, staticRenderFns } from "./CmTabs.vue?vue&type=template&id=14321a7a"
import script from "./CmTabs.vue?vue&type=script&lang=ts"
export * from "./CmTabs.vue?vue&type=script&lang=ts"
import style0 from "./CmTabs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TabItem: require('/app/components/base/TabItem/TabItem.vue').default,CmAccordion: require('/app/components/modules/CmAccordion/CmAccordion.vue').default})
